import { useEffect, useState } from "react";

interface Props {
  label?: string;
  id: string;
  defaultValue?: boolean;
  onCheckedChange: any;
  paddingLeft?: any;
  disabled?: boolean;
}

const PlainCheckBox = (props: Props) => {
  const [checked, setChecked] = useState(props.defaultValue);

  useEffect(() => {
    setChecked(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <div className="col-sm-2 form-switch">
      <input
        onClick={() => {
          setChecked(!checked);
          props.onCheckedChange(!checked);
        }}
        className="form-check-input"
        type="checkbox"
        id={props.id}
        checked={checked}
        {...(props.disabled ? { disabled: true } : {})}
      />
    </div>
  );
};

export default PlainCheckBox;
